import type { MultilingualNodeConfig, MultilingualProperty } from "../../schemas/index.ts";
import { isMultilingualProperty, isNestingProperty } from "./filterFunctions.ts";

export const extractMultilingualProperties = (
  config: MultilingualNodeConfig,
  basePath?: string,
): { path: string; translations: MultilingualProperty }[] =>
  Object.entries(config).flatMap(([name, value]) => {
    const path = basePath ? `${basePath}.${name}` : name;
    return isMultilingualProperty(value)
      ? [{ path, translations: value.__ml }]
      : isNestingProperty(value)
        ? extractMultilingualProperties(value, path)
        : [];
  });
